import { FaqsContainer } from '@/modules/Faq';

export const Faqs = (): JSX.Element => <FaqsContainer />;

export default Faqs;
